import React, { useEffect, useState, useRef } from 'react';
import { ArticleService } from '../../../../../services/ArticleService';
import { EditionService } from '../../../../../services/EditionService';
import { Spinner, Card, Tabs, Tooltip, Row, Col, Accordion, Button, Table, Alert, Form, Dropdown, OverlayTrigger, Popover, InputGroup, FormControl } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import ErrorManager from "../../../../error-manager/ErrorManager";
import ConfirmDialog from '../../../../confirm-dialog/ConfirmDialog';
import Pagination from '../../../../../components/pagination/Pagination';
import { currencyFormat, getFile } from '../../../../../helper/Helper'
import { GlobalContext } from "../../../../../services/GlobalProvider";
import SendMailDialog from "../../../../../components/send-mail-dialog/SendMailDialog";


const Factures = (props) => {

    const { parametres } = React.useContext(GlobalContext);

    const [getFacturesLoading, setGetFacturesLoading] = useState(false)
    const [facturesData, setFacturesData] = useState()
    const [globalError, setGlobalError] = useState()
    const [currentPagination, setCurrentPagination] = useState(1)
    const [periodeValue, setPeriodeValue] = useState("")
    const [sendMailDialog, setSendMailDialog] = useState({})

    const searchInput = useRef("");

    let facturesParams = useRef({
        'start': 0,
        'limit': 10,
        'family': null,
        'search': null,
        'filters': null,
        'sort': 'date',
        'order': 'desc',
        'fields': "_id,type,code,date,client_nom,client_id,observation,total_remise,total_taxes,statut,total_prix_revient,total_brut_ht,total_net_ht,total_ttc"
    });

    const dateStart = useRef("");
    const dateEnd = useRef("");

    useEffect(() => {
        getFactures()
    }, []);

    function changePagination(p) {
        setCurrentPagination(p)
        facturesParams.current['start'] = (facturesParams.current.limit * p) - facturesParams.current.limit
    }

    function onChangePagination(p) {
        changePagination(p)
        getFactures()
    }

    let getFacturesTimeOut;
    function getFactures() {
        window.clearTimeout(getFacturesTimeOut);
        getFacturesTimeOut = window.setTimeout(function () {
            setGetFacturesLoading(true)
            setGlobalError()
            ArticleService.getFactures(props.folderId, props.article._id, facturesParams.current).then(res => {
                setGetFacturesLoading(false)
                setFacturesData(res.data ? res.data.data : null)
            }).catch(error => {
                setGetFacturesLoading(false)
                setGlobalError(error)
            });
        }, 600);
    }

    function changeSearchValue(value) {
        facturesParams.current['search'] = value
        changePagination(1)
        facturesParams.current['start'] = 0
        getFactures()
    }

    function removeSearchValue() {
        searchInput.current.value = ""
        changeSearchValue()
    }

    function Split({ title, value, border }) {
        return (
            <div className={"d-flex justify-content-between py-2 " + (border ? "border-bottom" : "")}>
                <span className="pe-4 text-gray-500">{title}</span>
                <span className="">{value}</span>
            </div>
        )
    }

    function onDateChange(e) {
        if (e.target.name == "date-debut") {
            if (e.target.value) {
                setDateDebut(e.target.value)
            } else {
                const index = facturesParams.current?.filters?.['filter[date]']?.findIndex(element => element.operator == '>=');
                facturesParams.current?.filters?.['filter[date]'].splice(index, 1);
            }
        }
        if (e.target.name == "date-fin") {
            if (e.target.value) {
                setDateFin(e.target.value)
            } else {
                const index = facturesParams.current?.filters?.['filter[date]']?.findIndex(element => element.operator == '<=');
                facturesParams.current?.filters?.['filter[date]'].splice(index, 1);
            }
        }
        if (facturesParams.current?.filters?.['filter[date]']?.length == 0) {
            console.log('DELETE')
            delete facturesParams.current?.filters?.['filter[date]']
        }
        getFactures()
        changePagination(1)
    }

    function setDateDebut(date) {
        let filterDateStart = facturesParams.current?.filters?.['filter[date]']?.find((element) => element.operator == '>=')
        if (filterDateStart) {
            filterDateStart.value = date
        } else {
            if (facturesParams.current?.filters?.['filter[date]']) {
                facturesParams.current?.filters?.['filter[date]'].push({ operator: ">=", value: date })
            } else {
                facturesParams.current['filters'] = { 'filter[date]': [{ operator: ">=", value: date }] }
            }
        }
        dateStart.current.value = date
    }

    function setDateFin(date) {
        let filterDateEnd = facturesParams.current?.filters?.['filter[date]']?.find((element) => element.operator == '<=')
        if (filterDateEnd) {
            filterDateEnd.value = date
        } else {
            if (facturesParams.current?.filters?.['filter[date]']) {
                facturesParams.current?.filters?.['filter[date]'].push({ operator: "<=", value: date })
            } else {
                facturesParams.current['filters'] = { 'filter[date]': [{ operator: "<=", value: date }] }
            }
        }
        dateEnd.current.value = date
    }

    function changePeriode(e) {
        setPeriodeValue(e.target.value)
        if (e.target.value) {
            var dateStart = new Date(
                new Date().getFullYear(),
                new Date().getMonth() - e.target.value + 1,
                "01"
            );
            var dateEnd = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
            setDateDebut(dateStart.toISOString().slice(0, 10))
            setDateFin(dateEnd.toISOString().slice(0, 10))
            getFactures()
        } else {
            removePeriode()
        }
        changePagination(1)
    }

    function prevNextPeriode(operatorStr) {
        let periodeValuePosNeg = operatorStr == "negative" ? -Math.abs(periodeValue) : Math.abs(periodeValue)
        let actualDateStart = new Date(dateStart.current.value.replace(/-/g, '\/'));
        let actualDateEnd = new Date(dateEnd.current.value.replace(/-/g, '\/'));
        var newDateStart = new Date(
            actualDateStart.getFullYear(),
            actualDateStart.getMonth() + periodeValuePosNeg,
            "01"
        );
        var newDateEnd = new Date(
            actualDateEnd.getFullYear(),
            actualDateEnd.getMonth() + periodeValuePosNeg + 1, 0
        );
        setDateDebut(newDateStart.toISOString().slice(0, 10))
        setDateFin(newDateEnd.toISOString().slice(0, 10))
        getFactures()
        changePagination(1)
    }

    function removePeriode() {
        setPeriodeValue("")
        setDateDebut("")
        setDateFin("")
        delete facturesParams.current?.filters?.['filter[date]']
        changePagination(1)
        getFactures()
    }

    function downloadPDF(facture) {
        EditionService.getFacture(props.folderId, facture._id, "pdf").then(res => {
            if (!res.data) {
                setGlobalError({ statusText: res.statusText })
            } else {
                getFile(res.data, `Facture ${facture.code} - ${facture.client_nom}`, "pdf")
            }
        }).catch(error => {
            setGlobalError(error)
        });
    }

    function sendEmail(facture) {
        setSendMailDialog({
            "clientId": facture.client_id,
            "folderId": props.folderId,
            "documentType": "factures",
            "documentId": facture._id,
            "show": true
        })
    }

    return (
        <>
            {globalError && <ErrorManager error={globalError} />}
            <SendMailDialog clientId={sendMailDialog.clientId} folderId={sendMailDialog.folderId} documentType={sendMailDialog.documentType} documentId={sendMailDialog.documentId} show={sendMailDialog.show} setCloseModal={() => setSendMailDialog({ show: false })} />
            {!globalError &&
                <span className='mb-3 d-block'>
                    <div className="d-flex">
                        <div className="flex-fill">
                            <InputGroup>
                                <i className="material-icons input-icon text-gray-400">search</i>
                                <FormControl
                                    ref={searchInput}
                                    className="rounded-start input-icon-space"
                                    placeholder="Rechercher"
                                    type="text"
                                    onChange={e => changeSearchValue(e.target.value)}
                                />
                                {searchInput.current.value &&
                                    <Button className="border border-start-0" variant="gray-100" onClick={() => removeSearchValue()}><i className="material-icons">close</i></Button>
                                }
                            </InputGroup>
                        </div>
                    </div>
                    <div className="bg-gray-100 p-3 rounded mt-3">
                        <Row>
                            <Col md={4}>
                                <p className="small mb-1">Filtrer par période</p>
                                <Form.Select size="sm" value={periodeValue} onChange={changePeriode}>
                                    <option value="">Personnalisée</option>
                                    <option value="3">3 mois</option>
                                    <option value="6">6 mois</option>
                                    <option value="12">1 an</option>
                                </Form.Select>
                            </Col>
                            <Col md={8}>
                                <p className="small mb-1">Date de début / date de fin</p>
                                <InputGroup className="">
                                    {periodeValue &&
                                        <Button size="sm" variant="secondary" onClick={() => prevNextPeriode("negative")}>
                                            <i className="material-icons">arrow_back_ios_new</i>
                                        </Button>
                                    }
                                    <Form.Control
                                        disabled={periodeValue}
                                        size="sm"
                                        ref={dateStart}
                                        onChange={onDateChange}
                                        name="date-debut"
                                        placeholder="Date de début"
                                        type="date"
                                    />
                                    <Form.Control
                                        disabled={periodeValue}
                                        size="sm"
                                        ref={dateEnd}
                                        onChange={onDateChange}
                                        name="date-fin"
                                        placeholder="Date de fin"
                                        type="date"
                                    />
                                    {(dateStart.current.value || dateEnd.current.value) &&
                                        <Button size="sm" variant="dark" onClick={() => removePeriode()}>
                                            <i className="material-icons">close</i>
                                        </Button>
                                    }
                                    {periodeValue &&
                                        <Button size="sm" variant="secondary" onClick={() => prevNextPeriode("positive")}>
                                            <i className="material-icons">arrow_forward_ios</i>
                                        </Button>
                                    }
                                </InputGroup>
                            </Col>
                        </Row>
                    </div>
                </span>

            }

            {getFacturesLoading && <span className="hloader"></span>}

            {(!getFacturesLoading && (facturesData?.count == 0 || !facturesData?.count) && !globalError) && <em>- Aucun élément trouvé -</em>}

            {(!getFacturesLoading && !globalError && facturesData?.factures.length > 0) &&
                <>
                    <Row className="mb-4" >
                        <Col>
                            <Split title={`Chiffre d'affaire HT (${parametres?.general?.devise_dossier})`} border value={currencyFormat(facturesData.chiffre_affaire_ht)} />
                            <Split title="Quantité vendue" value={facturesData.quantite_vendue} />
                        </Col>
                    </Row>
                    <Accordion>
                        {facturesData?.factures.map(facture => (
                            <Accordion.Item key={facture._id} eventKey={facture._id} className="border-0 mb-2">
                                <Accordion.Header>
                                    {facture.type == "facture" &&
                                        <span className="py-1 px-2 bg-primary rounded text-white fw-bold me-2">F</span>
                                    }
                                    {facture.type == "avoir" &&
                                        <span className="py-1 px-2 bg-success rounded text-white fw-bold me-2">A</span>
                                    }
                                    <span className="d-flex w-100">{facture.client_nom} le {new Date(facture.date).toLocaleDateString()} <span className="ms-auto me-4 text-gray-600">{currencyFormat(facture.total_ttc)} {parametres?.general?.devise_dossier} TTC</span></span>
                                </Accordion.Header>
                                <Accordion.Body className="px-1">
                                    <div className="d-flex align-items-center py-2">
                                        <div className="me-auto">
                                            <p className="m-0">{facture.client_nom}</p>
                                            <p className="m-0">{facture.type} {facture.code}</p>
                                        </div>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="secondary" className='no-btn-caret'>
                                                <i className="material-icons i-lg">more_horiz</i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item target="_blank" href={`/${props.folderId}/factures/?factureId=${facture._id}`}>Afficher</Dropdown.Item>
                                                <Dropdown.Item onClick={() => downloadPDF(facture)}>Imprimer</Dropdown.Item>
                                                <Dropdown.Item onClick={() => sendEmail(facture)}>Envoyer par mail</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <Row>
                                        <Col>
                                            {/* <Split border title="Type" value={facture.type} />
                                            <Split border title="Code" value={facture.code} /> */}
                                            <Split border title="Date" value={new Date(facture.date).toLocaleString()} />
                                            <Split border title="Client nom" value={facture.client_nom} />
                                            <Split border title="Observation" value={facture.observation} />
                                            <Split border title={`Total prix revient (${parametres?.general?.devise_dossier})`} value={currencyFormat(facture.total_prix_revient)} />
                                            <Split border title={`Total brut hors taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(facture.total_brut_ht)} />
                                            <Split border title={`Total net hors taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(facture.total_net_ht)} />
                                            <Split border title={`Total remise (${parametres?.general?.devise_dossier})`} value={currencyFormat(facture.total_remise)} />
                                            <Split border title={`Total montant taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(facture.total_taxes?.montant_total)} />
                                            <Split border title={`Total TTC (${parametres?.general?.devise_dossier})`} value={currencyFormat(facture.total_ttc)} />
                                            <Split border title="Statut" value={facture.statut} />
                                        </Col>
                                    </Row>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                    <Pagination className="mt-3" itemsLength={facturesData?.total} elementsPerPage={facturesParams.current.limit} currentPagination={currentPagination} changePagination={p => onChangePagination(p)} />
                </>
            }
        </>
    );
}
export default Factures;